
/* eslint-disable */
<template>
  <van-tabbar v-model="active" active-color="#F18A2E">
    <van-tabbar-item v-for="(item,index) in tabbarList" :key="index" @click="toPage(item)">
      <span>{{ item.name }}</span>
      <img
        v-if="item.link === '/startTest'"
        slot="icon"
        slot-scope="props"
        :src="props.active ? item.active : item.normal"
        style="width: 50px;height: 50px;margin-top: -23px;margin-bottom: -6px;z-index: 99999;position: relative"
      >
      <img
        v-else
        slot="icon"
        slot-scope="props"
        :src="props.active ? item.active : item.normal"
      >
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { getSwitchAccountId } from '@/utils/auth'
export default {
  data() {
    return {
      active: 0,
      tabbarList: [
        {
          normal: require('@/assets/images/tabbar/home.png'),
          active: require('@/assets/images/tabbar/home-active.png'),
          link: '/home',
          name: this.$t('routerBase.homepage'),
          flag: false
        },
        {
          normal: require('@/assets/images/tabbar/history.png'),
          active: require('@/assets/images/tabbar/history-active.png'),
          link: '/history',
          name: this.$t('routerBase.history'),
          flag: true
        },
        {
          normal: require('@/assets/images/tabbar/measur.png'),
          active: require('@/assets/images/tabbar/measur.png'),
          link: '/startTest',
          name: this.$t('routerBase.starttest'),
          flag: true
        },
        {
          normal: require('@/assets/images/tabbar/family.png'),
          active: require('@/assets/images/tabbar/family-active.png'),
          link: '/family/list',
          name: this.$t('routerBase.family'),
          flag: true
        },
        {
          normal: require('@/assets/images/tabbar/setting.png'),
          active: require('@/assets/images/tabbar/setting-active.png'),
          link: '/MyInfo',
          name: this.$t('routerBase.setting'),
          flag: false
        }
      ]
    }
  },
  watch: {
    $route(to) {
      console.log(to.path)
      switch (to.path) {
        case '/history':
          this.active = 1
          break
        case '/startTest':
          this.active = 2
          break
        case '/family/list':
          this.active = 3
          break
        case '/MyInfo':
          this.active = 4
          break
        case '/home':
          this.active = 0
      }
    }
  },
  created() {
    switch (this.$route.path) {
      case '/history':
        this.active = 1
        break
      case '/startTest':
        this.active = 2
        break
      case '/family/list':
        this.active = 3
        break
      case '/MyInfo':
        this.active = 4
        break
      case '/home':
        this.active = 0
    }
  },
  mounted() {
    window.webShow = this.webShow
    window.webHide = this.webHide
  },
  methods: {
    toPage: function(item) {
      var accountId = getSwitchAccountId()
      var params = {
        accountId: accountId
      }
      if (item.link === '/startTest') { // 开始测量
        console.log('准备调用开始测量...')
        console.log('当前账户的AccountId-->' + accountId)
        startTest(params)
      } else if (item.link === '/uploadDevice') {
        console.log('当前账户的AccountId-->' + accountId)
        uploadDevice(params)
      } else {
        this.$router.push(item.link)
      }
      console.log('link-->' + item.link)
      // 记录最后一次点击active值
      if (item.link !== '/startTest' && item.link !== '/uploadDevice' && item.link !== '/historyRecord') {
        sessionStorage.setItem('lastClickUrl', item.link)
        // console.log('最后一次点击--》' + this.active)
        // sessionStorage.setItem('lastActive', this.active)
      }
    },
    webShow() {
      /* var active = sessionStorage.getItem('lastActive')
      console.log('获取最后一次点击--》' + active)
      this.active = active*/
      testResult()
    },
    webHide() {
    }
  }
}
</script>

<style lang="scss">
  .van-tabbar {
    .van-tabbar-item__icon {
      margin-bottom: 4px;
    }
    .van-icon {
      font-size: 22px;
    }
    .van-icon-manager-o {
      font-size: 20px;
      margin-bottom: 1px;
    }
  }
</style>

